import Head from 'next/head';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import ContactUsComponent from "../../components/ContactUsComponent";
import { _fetchFooterCmsData } from "../../helper/service";
import { AxiosInstance } from "../../utilities";


export default function GetInTouchPage(props) {

  return (    <GoogleReCaptchaProvider
    reCaptchaKey={`${process.env.REACT_APP_RECAPTCHA_KEY}`}
    scriptProps={{
      async: false,
      defer: false,
      appendTo: "head",
      nonce: undefined,
    }}
  >
    <Head>
      <link rel="canonical" href={`${process.env.BASE_URL}/contact-us`} />
    </Head>
    <ContactUsComponent {...props} />{" "}
  </GoogleReCaptchaProvider>);
}

const initialCmsData = {
  title: null,
  description: null,
  phoneTitle: null,
  phone: null,
  img: null,
  img_text: null,
  email: "",
}

export async function getServerSideProps() {
  let cmsData = initialCmsData;
  let seo = "";

  const params = { slug: "contact-us" };
  await AxiosInstance(4008, "application/json")
  .post("/pages", params)
  .then((resp) => {
    const response = resp?.data;
    if (response?.status == "200") {
      const responseData = response?.data;
      seo = responseData?.seo
      let contactUsClone = { ...cmsData };
        responseData?.data.forEach((item) => {
          if (item.key === "contact_us") {
            contactUsClone.title = item.value;
            contactUsClone.description = item.description;
          }
          if (item.key === "phone") {
            contactUsClone.phone = item.value;
          }
          if (item.key === "image") {
            contactUsClone.img = item.value;
            contactUsClone.img_text = item.description;
          }
          if (item.key === "email") {
            contactUsClone.email = item.value;
          }
        });
        cmsData = {...contactUsClone};
    }
  })
    .catch((err) => console.log(err));

  const footerData = await _fetchFooterCmsData();
  const seoData = seo === undefined ? "" : seo

  return {
    props: {
      cmsData,
      seoData,
      footerData,
    },
  };
}